export const removePrefixFromFields = (fields, formId) => {
  return Object.keys(fields).reduce((newFields, key) => {
    const newKey = key.replace(`${formId}__`, '');
    newFields[newKey] = fields[key];
    return newFields;
  }, {});
};

export const fieldsWithValuesOnly = fields => {
  return Object.keys(fields).reduce((accumulator, key) => {
    const { value } = fields[key];
    accumulator[key] = value;
    return accumulator;
  }, {});
};

export const generateInitialValuesFromMultipageForm = (
  values,
  excludedKeys = ['password', 'acceptTerms']
) => {
  return Object.keys(values).reduce((accumulator, key) => {
    if (excludedKeys.includes(key)) return accumulator;
    const value = values[key];
    accumulator[key] = { value };
    return accumulator;
  }, {});
};
